"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    errorApi: undefined,
    errorJS: undefined,
    reportImmediatly: false,
    configuration: {
        allowHttpCodes: [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511],
    }
};
function errorsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.NOTIFY_ERROR: {
            return __assign(__assign({}, state), { errorJS: action.payload.errorJS, reportImmediatly: action.payload.reportImmediatly });
        }
        case types_1.NOTIFY_API_ERROR: {
            if (state.configuration.allowHttpCodes.findIndex(function (c) { var _a; return c === ((_a = action.payload.errorApi) === null || _a === void 0 ? void 0 : _a.status); }) !== -1 || action.payload.byPassAllowedCode) {
                return __assign(__assign({}, state), { errorApi: action.payload.errorApi, reportImmediatly: action.payload.reportImmediatly });
            }
            return (state);
        }
        case types_1.SET_CONFIGURATION:
            return __assign(__assign({}, state), { configuration: action.payload });
        case types_1.CLEAR_ERROR: {
            return __assign(__assign({}, state), { errorApi: undefined, errorJS: undefined, reportImmediatly: false });
        }
        default:
            return state;
    }
}
exports.errorsReducer = errorsReducer;
//# sourceMappingURL=reducer.js.map